import { render, staticRenderFns } from "./VolunteerRegistration.vue?vue&type=template&id=2bc7411c&scoped=true&"
import script from "./VolunteerRegistration.vue?vue&type=script&lang=js&"
export * from "./VolunteerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerRegistration.vue?vue&type=style&index=0&id=2bc7411c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7411c",
  null
  
)

export default component.exports